<style src="./ButtonSubmit.scss" lang="scss" scoped></style>
<template>
  <div class="cp1-button-submit-container">
    <button
      :disabled="disabled"
      v-if="state === 'REPOSE'"
      class="cp1-small-button cp1-button__success">
      <component :is="iconSave" />
      {{ label }}
    </button>
    <div class="cp1-small-button cp1-button__success button-wait" v-if="state === 'WAIT'">
      <icon-wait />
      {{ label }}
    </div>
    <div class="cp1-small-button cp1-button__success button-disabled" v-if="state === 'DISABLED'">
      <icon-lock />
      {{ label }}
    </div>
  </div>
</template>

<script>
import { IconWait, IconLock } from '@/components/primitives/icons'

export default {
  name: 'ButtonSubmit',
  components: {
    IconWait,
    IconLock
  },
  props: {
    state: {
      default: 'REPOSE'
    },
    label: {
      default: 'Enviar'
    },
    iconSave: {
      default: null
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/cp1-button-submit/ButtonSubmit.vue